@let show = showSearchInput();

@if (show) {
  <button
    type="button"
    class="fixed top-0 left-0 h-screen w-full bg-black/20"
    [attr.aria-label]="'header.typeahead.close' | translate"
    (click)="resetSearch()"
  ></button>
}
@let fullScreen = showFullSize();
@let sidePadding = fullScreen ? headerPadding() : undefined;
<div
  class="custom-scrollbar bg-light-main fixed top-0 left-1/2 z-50 flex h-dvh w-full -translate-x-1/2 flex-col items-center overflow-hidden overflow-y-auto whitespace-nowrap shadow-md duration-200"
  [ngClass]="{
    block: show,
    hidden: !show,
    'md:top-5 md:h-auto md:max-w-xl lg:top-10 lg:max-w-3xl': !fullScreen
  }"
>
  @let data = typeaheadData();
  @let loadingData = isLoading();
  @let mainCols = mainSections();
  @let asideCols = asideSections();
  <form
    class="p border-medium-main relative flex w-full max-w-xs flex-row items-center justify-center border-b bg-transparent text-left duration-200 md:max-w-md lg:max-w-lg"
    (submit)="onSearchSubmit($event)"
  >
    <input
      #searchInput
      [placeholder]="'header.typeahead.searchPlaceholder' | translate"
      type="search"
      class="text-dark-main bg-light-main placeholder:text-medium-main w-full border-none py-4 pr-24 pl-4 focus:ring-0"
      [formControl]="searchForm"
      (keydown.enter)="onSearchSubmit($event)"
    />
    <div class="absolute top-1/2 right-0 flex -translate-y-1/2 items-center gap-2">
      <button
        type="submit"
        class="text-dark-main hover:text-primary-main focus:text-primary-main flex size-8 items-center justify-center p-2 duration-200"
        [attr.aria-label]="'header.typeahead.search' | translate"
      >
        <gs-icon iconName="magnifying-glass" iconWeight="light" class="pointer-events-none"></gs-icon>
      </button>
      <button
        type="button"
        (click)="searchForm.reset(); showSearchInput.set(false)"
        class="hover:text-danger-main bg-light-main text-dark-main ml-4 flex size-8 items-center justify-center p-1 duration-200"
        [attr.aria-label]="'header.typeahead.clear' | translate"
      >
        <gs-icon iconName="x" iconWeight="light"></gs-icon>
      </button>
    </div>
  </form>
  <div
    class="text-light-contrast bg-light-main custom-scrollbar flex w-full flex-col overflow-x-hidden overflow-y-auto whitespace-nowrap md:max-h-[80vh] md:justify-between lg:flex-row"
    [ngClass]="{
      'pt-8 lg:gap-4 lg:pt-5': fullScreen
    }"
    [gsResponsive]="{ 'padding-inline': sidePadding }"
  >
    @if (mainCols.length) {
      <div
        class="custom-scrollbar overflow-x-hidden max-lg:w-full lg:overflow-y-auto"
        [ngClass]="asideCols.length ? 'lg:w-2/3' : 'lg:w-full'"
      >
        @for (section of mainCols; track section.key) {
          <section class="p-4 last:mb-0 md:mb-4" [ngClass]="{ 'px-0 lg:p-0': fullScreen }">
            @if (!fullScreen && section.titleKey) {
              <h3 class="mb-4">
                {{ section.titleKey | translate }}
              </h3>
            }
            @if (searchForm.valid && !data?.items?.data) {
              <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
            }
            @if (!loadingData && hasResultsForType(section.key)) {
              <div
                class="gap-4"
                [ngClass]="{
                  'flex flex-col': !fullScreen,
                  'xxl:grid-cols-5 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-3 xl:grid-cols-4': fullScreen
                }"
              >
                @for (item of itemsForSection(section.key); track item.iD) {
                  @if (section.layout === 'articles') {
                    <ng-container *ngTemplateOutlet="articleItem; context: { item: item, fullScreen: fullScreen }"></ng-container>
                  } @else {
                    <ng-container
                      *ngTemplateOutlet="mediaItem; context: { item: item, section: section, fullScreen: fullScreen }"
                    ></ng-container>
                  }
                }
              </div>
            } @else if (!loadingData && section.emptyKey && (section.layout === 'articles' || !fullScreen)) {
              <p class="block text-base whitespace-nowrap">
                {{ (searchForm.value ? section.emptyKey : 'header.typeahead.enterSearchTerm') | translate }}
              </p>
            }
          </section>
        }
      </div>
    }
    @if (asideCols.length) {
      <div
        class="custom-scrollbar w-auto justify-between p-4 max-lg:w-full md:max-h-[60vh] lg:overflow-x-hidden lg:overflow-y-auto"
        [ngClass]="[mainCols.length ? 'lg:w-1/3' : 'lg:w-full', fullScreen ? 'px-0 lg:p-0' : '']"
      >
        @for (section of asideCols; track section.key) {
          <section class="mb-4 last:mb-0">
            @if (section.titleKey) {
              <h3 class="mb-4">
                {{ section.titleKey | translate }}
              </h3>
            }
            @if (searchForm.valid && !data?.items?.data) {
              <ng-container *ngTemplateOutlet="loadingSpinner"></ng-container>
            }
            @if (!loadingData && hasResultsForType(section.key)) {
              <div class="flex flex-col gap-4">
                @for (item of itemsForSection(section.key); track item.iD) {
                  <a [href]="systemService.getLink(item.detailLink)" class="p hover:text-secondary-main cursor-pointer whitespace-normal">
                    {{ item.title }}
                  </a>
                }
              </div>
            } @else if (!loadingData && section.emptyKey) {
              <p class="block text-base whitespace-nowrap">
                {{ (searchForm.value ? section.emptyKey : 'header.typeahead.enterSearchTerm') | translate }}
              </p>
            }
          </section>
        }
      </div>
    }
  </div>
  @let searchPathValue = searchPath();
  @if (!loadingData && hasAnyResults() && searchPathValue) {
    <div
      class="flex w-full justify-center self-center p-4 md:justify-start md:self-start"
      [ngClass]="{
        'px-0 lg:py-5': fullScreen
      }"
      [gsResponsive]="{ 'padding-inline': sidePadding }"
    >
      <a
        class="w-full text-center duration-200 md:w-auto"
        [href]="systemService.getLink(searchPathValue)"
        [ngClass]="actionButtonClasses"
        [ngStyle]="actionButtonStyles"
      >
        {{ 'header.typeahead.showAllResults' | translate }}
      </a>
    </div>
  }
</div>

<!-- Article item (with price and availability) -->
<ng-template #articleItem let-article="item" let-fullScreen="fullScreen">
  <a
    [href]="systemService.getLink(article.detailLink)"
    class="group flex gap-2"
    [ngClass]="{
      'flex-col': fullScreen,
      'w-full flex-row items-center': !fullScreen
    }"
  >
    <div
      class="relative shrink-0 overflow-hidden"
      [ngClass]="[styleService.getBorderRadiusClass(borderRadius()), !fullScreen ? 'size-12' : 'h-60 w-full']"
    >
      @if (fullScreen) {
        <shared-teaser-badge
          itemType="Article"
          size="sm"
          [articleTeaser]="article.teaser"
          [articleTeaserColor]="article.teaserColor"
          [currentPrice]="article.priceInfo?.minKeyPrice?.value"
          [currency]="article.priceInfo?.currency?.sign"
          [oldPrice]="article.priceInfo?.minKeyOldPrice?.value"
          [isAvailableArticle]="article.available ?? false"
          [showAvailableStatusBadge]="true"
          [showDiscountBadge]="true"
          [showArticleTeaserBadge]="true"
        ></shared-teaser-badge>
      }
      <gs-optimized-image
        [photo]="article.photo"
        size="medium"
        mode="fill"
        sizes="240px"
        [alt]="article.photo?.alt ?? article.title ?? ''"
        [containerClass]="styleService.getBorderRadiusClass(borderRadius()) + (fullScreen ? ' h-60 w-full' : ' size-12')"
        objectFit="object-cover"
      />
    </div>
    <div
      class="text-dark-main group-hover:text-secondary-main flex w-full flex-col"
      [ngClass]="{
        'whitespace-nowrap': fullScreen,
        'whitespace-normal': !fullScreen
      }"
    >
      <div class="h4 overflow-hidden text-ellipsis" [title]="article.title">
        {{ article.title }}
      </div>
      <div class="p flex items-center gap-1 overflow-hidden" [title]="article.subTitle">
        @if (!fullScreen && systemService.isWebshop) {
          <span
            class="inline-block size-2 shrink-0 rounded-full"
            [ngClass]="article.available ? 'bg-secondary-main' : 'bg-danger-main'"
            aria-hidden="true"
          ></span>
        }
        <span class="min-w-0 overflow-hidden text-ellipsis">{{ article.subTitle }}</span>
      </div>
      @if (!fullScreen && article.teaser) {
        <div class="text-xs" [style.color]="article.teaserColor">
          {{ article.teaser }}
        </div>
      }
    </div>
    @if (systemService.isWebshop && article.priceInfo && article.priceInfo.minKeyPrice && article.priceInfo.minKeyPrice.value) {
      <div
        class="flex text-lg font-normal"
        [ngClass]="{
          'text-secondary-main': article.priceInfo.minKeyOldPrice,
          'flex-col items-end text-right': !fullScreen
        }"
      >
        @if (article.priceInfo.countKeyPrices != undefined && article.priceInfo.countKeyPrices > 1) {
          <span class="mr-1 inline-block">
            {{ 'header.typeahead.from' | translate }}
          </span>
        }
        {{ article.priceInfo.minKeyPrice | formatCurrency }}
        @if (article.priceInfo.minKeyOldPrice) {
          <p class="text-dark-main font-light">
            {{ 'header.typeahead.instead' | translate }}
            <span class="line-through">
              {{ article.priceInfo.minKeyOldPrice | formatCurrency }}
            </span>
          </p>
        }
      </div>
    }
  </a>
</ng-template>

<!-- Item with image and title (reports, pages, videos) -->
<ng-template #mediaItem let-item="item" let-section="section" let-fullScreen="fullScreen">
  <a
    [href]="systemService.getLink(item.detailLink)"
    class="hover:text-secondary-main group flex gap-2"
    [ngClass]="{
      'flex-col': fullScreen,
      'w-full flex-row items-center': !fullScreen
    }"
  >
    <div
      class="relative shrink-0 overflow-hidden"
      [ngClass]="[styleService.getBorderRadiusClass(borderRadius()), !fullScreen ? 'size-12' : 'h-60 w-full']"
    >
      @if (fullScreen && section.badgeType) {
        <shared-teaser-badge
          [itemType]="section.badgeType"
          itemTypeColor="tertiary-main"
          size="sm"
          [showItemTypeBadge]="true"
        ></shared-teaser-badge>
      }
      <gs-optimized-image
        [photo]="item.photo"
        size="medium"
        mode="fill"
        sizes="240px"
        [alt]="item.photo?.alt ?? item.title ?? ''"
        [containerClass]="styleService.getBorderRadiusClass(borderRadius()) + (fullScreen ? ' h-60 w-full' : ' size-12')"
        objectFit="object-cover"
      />
    </div>
    <div
      class="p overflow-hidden text-ellipsis"
      [ngClass]="{
        'whitespace-nowrap': fullScreen,
        'whitespace-normal': !fullScreen
      }"
    >
      {{ item.title }}
    </div>
  </a>
</ng-template>

<!-- Loading Spinner -->
<ng-template #loadingSpinner>
  <gs-icon
    [ngClass]="isLoading() ? 'block' : 'hidden'"
    iconName="circle-notch"
    iconWeight="fill"
    class="text-primary-main mx-auto block animate-spin text-xl"
  ></gs-icon>
</ng-template>
